module.exports = __webpack_public_path__ + "static/media/sim-broadcasts-logo-gr-w.b6da6757.png";